import { createReducer } from '@reduxjs/toolkit';

import defaultState from './defaultState';
import { reducer as listByParentIdReducer } from './listByParentId';

const productCategoriesReducer = createReducer(
  defaultState,
  (builder) => {
    listByParentIdReducer(builder);
  },
);

export default productCategoriesReducer;
